// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2VRkA","tag-cross":"classes_tag-cross__1oQy6"};